import _ from 'lodash'
import HTTP from '@/utils/http'
import notification from '@/utils/notification'

// @TODO <sam_liang@epam.com>
// 1. Extract the common logic to a function for reusing
// 2. The request queues can be splitted several requests to a chunk, then send chunk via Promise.all
export async function getDataViaCache (url, query, payload = {}) {
  const { pageNumber = 500, httpMethod = 'get' } = payload
  const httpReqMethod = HTTP[httpMethod]
  const res = await httpReqMethod(url, {
    params: query,
    headers: { 'pagination_cache_request': true, 'pagination_number': pageNumber },
  })

  const pcrId = _.get(res, 'data.pcr_id', null)
  let result = []
  if (pcrId) {
    const requestNumber = _.get(res, 'data.pageSize', 0)
    for (let page = 0; page < requestNumber; page++) {
      try {
        const pagination = { 'pagination_page': page }
        const pageRes = await httpReqMethod(url, {
          params: { pcr_id: pcrId, ...pagination },
        })
        result.push(...pageRes.data)
      } catch (error) {
        notification.handleResponseError(error, 'cache')
        result = []
        break
      }
    }
  }
  return result
}
